import React from 'react';
import { FileText, Info, Shield, LayoutDashboard } from 'lucide-react';
export function SEONavigationSection() {
  const links = [{
    to: '/about',
    label: 'About ToxicDetector',
    description: 'Learn about our mission and forensic AI technology.',
    icon: <Info className="w-5 h-5" data-id="element-2989" />
  }, {
    to: '/dashboard',
    label: 'User Dashboard',
    description: 'Access your scan history and toxicity reports.',
    icon: <LayoutDashboard className="w-5 h-5" data-id="element-2990" />
  }, {
    to: '/privacy',
    label: 'Privacy Policy',
    description: 'How we protect your data with AES-256 encryption.',
    icon: <Shield className="w-5 h-5" data-id="element-2991" />
  }, {
    to: '/terms',
    label: 'Terms of Service',
    description: 'Usage guidelines and legal disclosures.',
    icon: <FileText className="w-5 h-5" data-id="element-2992" />
  }, {
    to: '/blog',
    label: 'Blog & Resources',
    description: 'Articles on gaslighting, narcissism, and toxic patterns.',
    icon: <FileText className="w-5 h-5" data-id="element-2993" />
  }];
  return <section className="py-16 bg-[#050505] border-t border-gray-900" data-id="element-2994">
      <div className="max-w-6xl mx-auto px-6" data-id="element-2995">
        <div className="mb-8" data-id="element-2996">
          <h2 className="text-2xl font-bold text-white uppercase tracking-wide mb-2" data-id="element-2997">
            Quick Links
          </h2>
          <p className="text-gray-500 font-mono text-sm" data-id="element-2998">
            Navigate our platform and resources.
          </p>
        </div>

        <nav aria-label="Secondary navigation" data-id="element-2999">
          <ul className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4" data-id="element-3000">
            {links.map((link, index) => <li key={index} data-id="element-3001">
                <a href={link.to} className="flex items-start gap-4 p-4 rounded-lg border border-gray-800 bg-[#0A0A0A] hover:border-gray-600 hover:bg-gray-900/50 transition-all group" data-id="element-3002">
                  <div className="mt-1 text-gray-500 group-hover:text-[#FF0000] transition-colors" data-id="element-3003">
                    {link.icon}
                  </div>
                  <div data-id="element-3004">
                    <span className="block text-white font-bold text-sm uppercase tracking-wide mb-1 group-hover:text-[#FF0000] transition-colors" data-id="element-3005">
                      {link.label}
                    </span>
                    <span className="block text-gray-500 font-mono text-xs" data-id="element-3006">
                      {link.description}
                    </span>
                  </div>
                </a>
              </li>)}
          </ul>
        </nav>
      </div>
    </section>;
}